import pkg from '../../package.json'

export const APP_VERSION = pkg.version || process.env.REACT_APP_VERSION
export const CS_PROTOCOL = process.env.REACT_APP_CS_PROTOCOL
export const CS_HOST = process.env.REACT_APP_CS_HOST

// Admin relocation notice. When REACT_APP_ADMIN_MOVED is 'true', every route renders
// the "admin has moved" page instead of the app and forwards to the new admin URL.
export const ADMIN_MOVED = process.env.REACT_APP_ADMIN_MOVED === 'true'
export const ADMIN_MOVED_URL =
  process.env.REACT_APP_ADMIN_MOVED_URL || 'https://control.eu.tixlio.com'
// Seconds before the moved page auto-forwards to ADMIN_MOVED_URL.
export const ADMIN_MOVED_REDIRECT_DELAY = Number(process.env.REACT_APP_ADMIN_MOVED_DELAY) || 8

const TENANT = window.location.host.split('.')[0]
export const CS_URL = `${CS_PROTOCOL}://${TENANT === 'localhost:3000' ? 'demo' : TENANT}.${CS_HOST}`

const QUERY_KEYS = {
  tenant: 'tenant',
  roles: 'roles',
  users: 'users',
  currencies: 'currencies',
  categories: 'categories',
  tickets: 'tickets',
  bundles: 'bundles',
  categoriesAndTickets: 'categories_and_tickets',
  transactions: 'transactions',
  transactionRegister: 'transactionRegister',
}

export const queryKeys = {
  tenant: () => [QUERY_KEYS.tenant] as const,
  roles: () => [QUERY_KEYS.roles] as const,
  role: (roleId: number | string) => [QUERY_KEYS.roles, roleId] as const,
  users: () => [QUERY_KEYS.users] as const,
  user: (userId: number | string) => [QUERY_KEYS.users, userId] as const,
  currencies: () => [QUERY_KEYS.currencies] as const,
  categories: () => [QUERY_KEYS.categories] as const,
  category: (categoryId: string) => [QUERY_KEYS.categories, categoryId] as const,
  tickets: (categoryId: string) => [QUERY_KEYS.categories, categoryId, QUERY_KEYS.tickets] as const,
  ticket: (categoryId: string, ticketId: string) =>
    [QUERY_KEYS.categories, categoryId, QUERY_KEYS.tickets, ticketId] as const,
  bundles: (categoryId: string) => [QUERY_KEYS.categories, categoryId, QUERY_KEYS.bundles] as const,
  buundle: (categoryId: string, bundleId: string) =>
    [QUERY_KEYS.categories, categoryId, QUERY_KEYS.bundles, bundleId] as const,
  categoriesAndTickets: () => [QUERY_KEYS.categoriesAndTickets] as const,
  transactionsByDate: (queryDate: string) => [QUERY_KEYS.transactions, queryDate] as const,
  transactionRegister: (todayDate: string) => [QUERY_KEYS.transactionRegister, todayDate] as const,
}

const API_BASE = {
  bi: 'bi',
  perms: 'perms',
  roles: 'roles',
  users: 'users',
  tenants: 'tenants',
  currencies: 'currencies',
  categories: 'categories',
  tickets: 'tickets',
  bundles: 'bundles',
  transactions: 'transactions',
}

export const apiUrls = {
  tenant: () => `/${API_BASE.tenants}/`,
  roles: () => `/${API_BASE.perms}/${API_BASE.roles}/`,
  role: (roleId: number | string) => `/${API_BASE.perms}/${API_BASE.roles}/${roleId}/`,
  users: () => `/${API_BASE.users}/`,
  user: (userId: number | string) => `/${API_BASE.users}/${userId}/`,
  currencies: () => `/${API_BASE.tenants}/${API_BASE.currencies}/`,
  categories: () => `/${API_BASE.tickets}/${API_BASE.categories}/`,
  category: (categoryId: string) => `/${API_BASE.tickets}/${API_BASE.categories}/${categoryId}/`,
  tickets: (categoryId: string) =>
    `/${API_BASE.tickets}/${API_BASE.categories}/${categoryId}/${API_BASE.tickets}/`,
  ticket: (categoryId: string, ticketId: string) =>
    `/${API_BASE.tickets}/${API_BASE.categories}/${categoryId}/${API_BASE.tickets}/${ticketId}/`,
  bundles: (categoryId: string) =>
    `/${API_BASE.tickets}/${API_BASE.categories}/${categoryId}/${API_BASE.bundles}/`,
  bundle: (categoryId: string, bundleId: string) =>
    `/${API_BASE.tickets}/${API_BASE.categories}/${categoryId}/${API_BASE.bundles}/${bundleId}/`,
  biTransactions: () => `/${API_BASE.bi}/${API_BASE.transactions}/`,
}

const NAV_BASE = {
  categories: 'ticket-categories',
  tickets: 'tickets',
  transactions: 'transactions',
  users: 'users',
  roles: 'roles',
  settings: 'settings',
  voucher: 'voucher',
}

export const navUrls = {
  login: () => '/login',
  dashboard: () => '/',
  export: () => '/export',
  vouchers: () => `/${NAV_BASE.voucher}`,
  transactions: () => `/${NAV_BASE.transactions}`,
  settings: () => `/${NAV_BASE.settings}`,
  roles: () => `/${NAV_BASE.roles}`,
  role: (roleId: string) => `/${NAV_BASE.roles}/${roleId}`,
  roleAdd: () => `/${NAV_BASE.roles}/add`,
  roleEdit: (roleId: string) => `/${NAV_BASE.roles}/${roleId}/edit`,
  users: () => `/${NAV_BASE.users}`,
  user: (userId: string) => `/${NAV_BASE.users}/${userId}`,
  userAdd: () => `/${NAV_BASE.users}/add`,
  userEdit: (userId: string) => `/${NAV_BASE.users}/${userId}/edit`,
  categories: () => `/${NAV_BASE.categories}`,
  category: (categoryId: string) => `/${NAV_BASE.categories}/${categoryId}`,
  categoryAdd: () => `/${NAV_BASE.categories}/add`,
  categoryEdit: (categoryId: string) => `/${NAV_BASE.categories}/${categoryId}/edit`,
  tickets: (categoryId: string) => `/${NAV_BASE.categories}/${categoryId}/${NAV_BASE.tickets}`,
  ticketAdd: (categoryId: string) =>
    `/${NAV_BASE.categories}/${categoryId}/${NAV_BASE.tickets}/add`,
  ticketEdit: (categoryId: string, ticketId: string) =>
    `/${NAV_BASE.categories}/${categoryId}/${NAV_BASE.tickets}/${ticketId}/edit`,
}
